module.exports = __webpack_public_path__ + "/static/images/file_mp3.png";